import { render, staticRenderFns } from "./ListadoEstablecimientos.vue?vue&type=template&id=d2115e10&"
import script from "./ListadoEstablecimientos.vue?vue&type=script&lang=ts&"
export * from "./ListadoEstablecimientos.vue?vue&type=script&lang=ts&"
import style0 from "./ListadoEstablecimientos.vue?vue&type=style&index=0&id=d2115e10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports